import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { Image, Text, View } from '@react-pdf/renderer';

import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { SafeImage } from '../SafeImage';

interface ExhibitionsProps {
  event: PublicEventDetailsResponse;
}

const Exhibitions = ({ event }: ExhibitionsProps) => {
  const { t } = useTranslation();

  return (
    <View style={globalStyles.body}>
      <Text
        style={{ ...globalStyles.bigTitle, color: event?.design?.themeColor }}
      >
        {t('partner-&-exhibitors')}
      </Text>

      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
        }}
      />

      <Text style={styles.description}>{t('partner-&-exhibitors-text')}</Text>

      <View
        style={{ flexDirection: 'column', width: '100%', maxWidth: 600 }}
        wrap={false}
      >
        <View style={{ width: '100%', maxWidth: 600 }}>
          <SafeImage
            style={styles.topImage}
            src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_1.jpg"
            debugLabel="partners-exhibitors-1"
          />
        </View>

        <View style={styles.imageRow}>
          <SafeImage
            style={{
              ...styles.thumbnail,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
            }}
            src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_2.jpg"
            debugLabel="partners-exhibitors-2"
          />

          <SafeImage
            style={styles.thumbnail}
            src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_3.png"
            debugLabel="partners-exhibitors-3"
          />

          <SafeImage
            style={{
              ...styles.thumbnail,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            }}
            src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_4.png"
            debugLabel="partners-exhibitors-4"
          />
        </View>
      </View>
    </View>
  );
};

export default Exhibitions;
